// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "selectableSegmentDesktop__airplane-2YB9P";
var _3 = "selectableSegmentMobile__airplane-1ELvq";
export { _1 as "__esModule", _2 as "selectableSegmentDesktop__airplane", _3 as "selectableSegmentMobile__airplane" }
export default { "__esModule": _1, "selectableSegmentDesktop__airplane": _2, "selectableSegmentMobile__airplane": _3 }
